import React, { useState } from 'react';
import css from './HostAccordion.module.css';
import classNames from 'classnames';
import IconPlusCircle from '../../../components/IconPlusCircle/IconPlusCircle';
import IconMinusCircle from '../../../components/IconMinusCircle/IconMinusCircle';

const HostAccordion = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = index => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className={css.accordion}>
      {items.map((item, index) => (
        <div
          className={classNames(css.accordionItem, index === activeIndex ? css.open : null)}
          key={index}
        >
          <div className={css.accordionHeader} onClick={() => handleToggle(index)}>
            <h3>{item.title}</h3>
            <span className={classNames(css.icon, index === activeIndex ? css.open : null)}>
              {index === activeIndex ? <IconMinusCircle /> : <IconPlusCircle />}
            </span>
          </div>
          {index === activeIndex && <div className={css.accordionContent}>{item.description}</div>}
        </div>
      ))}
    </div>
  );
};

export default HostAccordion;
